import { useCallback, useRef } from 'react';
import {
  GridApi,
  GridReadyEvent,
  SelectionChangedEvent,
} from 'ag-grid-community';
import { useSetAtom } from 'jotai';
import { dashboardClientAPIAtom, selectedRowsAtom } from './atoms';
import { ServerDashboardJob } from './dashboardType';

export const useGridHandlers = () => {
  const gridApiReference = useRef<GridApi | null>(null);
  const setSelectedRows = useSetAtom(selectedRowsAtom);
  const setDashboardClientAPI = useSetAtom(dashboardClientAPIAtom);

  const onGridReady = useCallback(
    (parameters: GridReadyEvent) => {
      gridApiReference.current = parameters.api;
      setDashboardClientAPI(parameters.api);
    },
    [setDashboardClientAPI]
  );

  const onSelectionChanged = useCallback(
    (event: SelectionChangedEvent) => {
      const selectedNodes = event.api.getSelectedRows() as ServerDashboardJob[];
      setSelectedRows(selectedNodes);
    },
    [setSelectedRows]
  );

  return {
    gridApiReference,
    onGridReady,
    onSelectionChanged,
  };
};
